/**
 * Daily average rating trend. Y axis is fixed to [3, 5] (almost all
 * reviews fall in that range — a wider domain visually flattens any
 * meaningful variation).
 */
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";

import ChartCard from "../ChartCard/ChartCard";
import {
  CHART_PALETTE,
  formatDateShort
} from "../../../../../constants/analytics.constants";

const TooltipBox = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div
      style={{
        background: CHART_PALETTE.ink,
        color: "#fff",
        fontSize: 11,
        padding: "6px 8px",
        borderRadius: 6,
        boxShadow: "0px 2px 4px rgba(0,0,0,0.25)"
      }}
    >
      <div style={{ color: "#A9A7BD", fontSize: 10 }}>
        {formatDateShort(label)}
      </div>
      <div style={{ fontWeight: 600, fontSize: 12, marginTop: 1 }}>
        {Number(payload[0].value).toFixed(2)} ★
      </div>
    </div>
  );
};

const RatingTrend = ({ data = [] }) => (
  <ChartCard title="Rating trend" subtitle="Daily avg grade">
    {data.length === 0 ? (
      <div style={{ flex: 1, display: "grid", placeItems: "center", color: "#8E8E8E", fontSize: 12 }}>
        No reviews yet
      </div>
    ) : (
      <ResponsiveContainer width="100%" height={180}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 4" stroke={CHART_PALETTE.inkLine} vertical={false} />
          <XAxis
            dataKey="date"
            tickFormatter={formatDateShort}
            tick={{ fontSize: 10, fill: CHART_PALETTE.axis }}
            axisLine={false}
            tickLine={false}
            interval="preserveStartEnd"
          />
          <YAxis
            domain={[3, 5]}
            tickFormatter={v => v.toFixed(1)}
            tick={{ fontSize: 10, fill: CHART_PALETTE.axis }}
            axisLine={false}
            tickLine={false}
            width={40}
          />
          <Tooltip content={<TooltipBox />} />
          <Line
            type="monotone"
            dataKey="avgGrade"
            stroke={CHART_PALETTE.ink}
            strokeWidth={2}
            dot={{ r: 2.5, stroke: CHART_PALETTE.ink, fill: "#fff" }}
            activeDot={{ r: 4, stroke: CHART_PALETTE.ink, fill: "#fff" }}
          />
        </LineChart>
      </ResponsiveContainer>
    )}
  </ChartCard>
);

export default RatingTrend;
